import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})
export class ChatbotComponent implements OnInit {

  @Input() email: string = '';

  isOpen: boolean = false;
  isMinimized: boolean = false;

  safeChatbotUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {

    let url = 'https://helpdesk-pro.dhanushinfotech.com/chatbot';

    if (this.email && this.email.trim().length > 3) {
      url += '/' + encodeURIComponent(this.email.trim());
    }

    this.safeChatbotUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openChat(): void {
    this.isOpen = true;
    this.isMinimized = false;
  }

  closeChat(): void {
    this.isOpen = false;
  }

  minimizeChat(): void {
    this.isMinimized = true;
  }

  expandChat(): void {
    this.isMinimized = false;
  }
}
